<script>
import { Element} from "@prismicio/helpers";
import * as prismicH from "@prismicio/helpers";

const promoTextSerializer = (type, element, content, children) => {
  switch (type) {
    case Element.paragraph: {
      return `<span class="pr-2 pl-3 leading-5">${children}</span>`;
    }
  }
}

const buttonSerializer = (type, element, content, children) => {
  switch (type) {
    case Element.paragraph: {
      return `<span class="font-bold text-[11px]">${children}</span>`;
    }
  }
}

export default {
  name: "Promotions",
  data() {
    return {
      currentPromotion: null
    }
  },
  async created() {
    const homepage = await this.$prismic.client.getSingle('homepage');

    const headerPromoData = homepage.data.header_promotions;

    // Check for fixed promotions
    const fixedPromotions = headerPromoData.filter(promo =>
        promo.start_date !== null &&
        promo.end_date !== null &&
        new Date(Date.parse(promo.start_date)) <= new Date() &&
        new Date(Date.parse(promo.end_date)) >= new Date()
    );

    if (fixedPromotions.length > 0) {
      this.currentPromotion = fixedPromotions[0];
    } else {
      // If there are no fixed promotions, check for evergreen promotions
      const evergreenPromotions = headerPromoData.filter(promo =>
          promo.start_date !== null &&
          promo.end_date === null &&
          new Date(Date.parse(promo.start_date)) <= new Date()
      );

      if (evergreenPromotions.length > 0) {
        this.currentPromotion = evergreenPromotions[0];
      }
    }
  },
  methods: {
    promoTextSerializer,
    buttonSerializer
  }
}
</script>

<template>
  <div v-if="currentPromotion !== null" class="bg-hurst-blue px-5 py-5 font-extrabold text-hurst-light-teal text-base text-center">
    <img v-if="currentPromotion.promo_icon" :src="`${currentPromotion.promo_icon.url}?auto=enhance,format`" class="inline-block" />
    <PrismicRichText :field="currentPromotion.promo_text" :html-serializer="promoTextSerializer" wrapper="span"/>
    <a v-if="currentPromotion.cta_link" :href="currentPromotion.cta_link.url" class="px-2 rounded-[40px] border-hurst-light-teal border block mt-3 md:mt-0 md:inline-flex">
      <PrismicRichText :field="currentPromotion.cta_text" :html-serializer="buttonSerializer" wrapper="span"/>
    </a>
  </div>
</template>

<style scoped>

</style>